<template>
	<confirmation-dialog
		:dialog="dialog"
		title="Record asset service"
		has-note-field
		:isConfirming="isConfirming"
		:is-disabled="serviceDate === null"
		@onConfirm="handleConfirm"
		@onCancel="$emit('onCancel', $event)">
		<div class="d-flex">
			<div class="mr-4">
				<DateInput
					v-model="serviceDate"
					label="Service Date"
					:rules="[rules.required]"/>
			</div>
			<div>
				<DateInput v-model="nextServiceDate" label="Next Service Date" class="mb-4"/>
			</div>
		</div>
	</confirmation-dialog>
</template>



<script>
	import DateInput from '@components/common/DateInput.vue';

	export default {
		name: 'AssetServiceDialog',
		components: { DateInput },
		props: {
			dialog: {
				type: Boolean,
				default: false,
			},
			isConfirming: {
				type: Boolean,
				default: false
			},
			previousServiceDate: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				serviceDateShowing: false,
				nextServiceDateShowing: false,
				serviceDate: null,
				nextServiceDate: null,
				rules : {
					required: value => {
						return !!value || 'Required.'
					}
				},
				confirmDisabled: true,
			}
		},
		computed: {
			nextServiceDateFormatted: {
				get(){
					return this.$options.filters.formatDate()
				}
			}
		},
		methods: {
			handleConfirm(note) {
				this.$emit('onConfirm', { note: note, serviceDate: this.serviceDate, nextServiceDate: this.nextServiceDate})
			}
		},
		created() {
			if (this.previousServiceDate)
				this.serviceDate = this.previousServiceDate
		}
	};
</script>


<style scoped>

</style>